import DataLoader from "dataloader";

import { ExtractedAmazonData } from "../components/Modules/Product/utils";
import { AffiliatesApiResponse } from "../types/ServerCustomContext";
import {
  extractAmazonDynmaicPricing,
  isAmazonASINItem,
} from "./extractDynamicPricing";
import { fetcher } from "./swr";

const amazonPricingDataLoader = new DataLoader(
  async (keys) => {
    const response = (await fetcher(
      `/_plat/api/affiliates?asin=${keys.join(",")}`,
    )) as AffiliatesApiResponse;

    return keys.map((key) => {
      const matchedItems = response?.results?.find(
        (item) => item.ASIN === key && isAmazonASINItem(item),
      );
      if (!matchedItems) return null;
      return extractAmazonDynmaicPricing(matchedItems);
    });
  },
  { maxBatchSize: 10 },
);

const extractAmazonLoader = (
  resolvedData: (Error | ExtractedAmazonData | null)[],
) => {
  return resolvedData
    .map((data) => {
      if (!(data instanceof Error)) {
        return data;
      }
    })
    .filter((data) => !!data);
};

export default amazonPricingDataLoader;
export { extractAmazonLoader };
